import { OpPatch } from "json-patch";
import { Axios } from "../../Axios";
import { TypeAlergia } from "../../../Models/Domain/Saude/Alergia";
import { TypeFichaDeSaude } from "../../../Models/Domain/Saude/FIcha/FichaDeSaude";

export interface IFiltroDaFichaDeSaude {
  ativo?: boolean;
  codigo?: number,
  codigoDaPessoa?: number
}

export class FichaDeSaudeDoAlunoService {
    public static listarFichas(filtro?: IFiltroDaFichaDeSaude){
        return Axios.get<TypeFichaDeSaude[]>(`quiron/saude/ficha-do-aluno`, {params: filtro});
    }

    public static listarFicha(codigo: number){
        return Axios.get<TypeFichaDeSaude[]>(`quiron/pessoa/aluno/${codigo}/ficha-de-saude`);
    }

    public static inserir(codigo:number, payload: TypeFichaDeSaude){
        return Axios.post<void>(`quiron/pessoa/aluno/${codigo}/ficha-de-saude`, payload);
    }

    public static atualizar(codigo:number, payload: TypeFichaDeSaude){
        return Axios.put<void>(`quiron/pessoa/aluno/${codigo}/ficha-de-saude`, payload);
    }

    public static atualizarComPatch(codigo: number, payload: OpPatch){
        return Axios.patch<void>(`quiron/pessoa/aluno/${codigo}/ficha-de-saude`, payload);
    }

    public static desativar(codigo: number){
        /* Não foi criada uma rota para desativar ainda, mas pode ser feito com um patch */
    }

    public static ativar(codigo: number){
        /* Não foi criada uma rota para ativar ainda, mas pode ser feito com um patch */
    }

}